import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustItems = [
    {
      icon: 'Shield',
      title: 'Medical License Verified',
      description: 'All users undergo professional credential verification'
    },
    {
      icon: 'Lock',
      title: 'HIPAA Compliant',
      description: 'Enterprise-grade security for patient data protection'
    },
    {
      icon: 'FileCheck',
      title: 'iRefer Guidelines',
      description: 'Evidence-based recommendations following RCR standards'
    },
    {
      icon: 'Award',
      title: 'Clinical Excellence',
      description: 'Trusted by healthcare professionals worldwide'
    }
  ];

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 mb-6">
        <Icon name="CheckCircle2" size={20} color="var(--color-success)" />
        <h3 className="text-base font-semibold text-foreground">Trusted Medical Platform</h3>
      </div>
      <div className="space-y-3">
        {trustItems?.map((item, index) => (
          <div key={index} className="flex items-start gap-3 p-3 bg-muted/50 rounded-lg border border-border">
            <div className="mt-0.5">
              <Icon name={item?.icon} size={18} color="var(--color-primary)" />
            </div>
            <div className="flex-1">
              <h4 className="text-sm font-medium text-foreground">{item?.title}</h4>
              <p className="text-xs text-muted-foreground mt-1">{item?.description}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 p-4 bg-primary/5 border border-primary/20 rounded-lg">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={18} color="var(--color-primary)" />
          <div>
            <p className="text-xs font-medium text-primary">New User Registration</p>
            <p className="text-xs text-muted-foreground mt-1">
              All new accounts require admin approval and medical license verification before access is granted.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;